import { createUseStyles } from 'react-jss'

import { colors } from 'components/common'

const usePillStyles = createUseStyles({
  pillWrapper: {
    padding: '0.25rem 0.75rem',
    margin: '0 0.5rem',
    borderRadius: 20,
    backgroundColor: 'rgba(161, 176, 36, 0.9)',
    color: '#fff',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    userSelect: 'none',
    '&.small': {
      fontSize: '0.75rem'
    },
    '&.medium': {
      fontSize: '0.875rem'
    },
    '&.large': {
      fontSize: '1.125rem'
    },
    '&.green': {
      backgroundColor: '#6fb83d'
    },
    '&.gray': {
      backgroundColor: colors.gray350
    },
    '&.red': {
      backgroundColor: '#eb1a21'
    },
    '&.orange': {
      backgroundColor: '#eb871c'
    },

    '&.clickable': {
      cursor: 'pointer',
      color: '#fff'
    }
  }
})

export { usePillStyles }
